// WHY A WORLD WON'T PLAY WELL HERE — the marks every desktop/web world list shows (the player's world select, the
// gallery's tiles), from the one source each: this device's own smoothness verdict (worldCost.ts) and the pushed
// TV's offer (cast/castTarget.ts). Empty = nothing to say.
import { castTargetName, castTargetUnavailable } from './cast/castTarget'
import { heavyHere } from './worldCost'

export function worldNotes(id: string): string[] {
  const notes: string[] = []
  if (heavyHere(id)) notes.push('too heavy for this device')
  const tv = castTargetName()
  if (tv && castTargetUnavailable(id)) notes.push(`not available on ${tv}`)
  return notes
}
